@for (item of navigationMenu(); track item.id) {
  @if (item.type === 'item') {
    <app-navigation-item [item]="item"></app-navigation-item>
  } @else if (item.type === 'group') {
    <app-navigation-group [item]="item"></app-navigation-group>
  } @else if (item.type === 'collapsable') {
    <app-navigation-collapsable [item]="item"></app-navigation-collapsable>
  }
}